var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebCompleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98,
    height: 52,
    viewBox: "0 0 98 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_33",
    x: 0,
    y: 0,
    width: 98,
    height: 52,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5463",
    "data-name": "Group 5463",
    transform: "translate(9.123 5.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(-0.123 0.059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-2",
    "data-name": "Rectangle 33",
    width: 80,
    height: 34,
    rx: 6,
    transform: "translate(9 6)",
    fill: "#03a9f4"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "AA21357556",
    transform: "translate(10.876 22.059)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "AmericanSansMedium, AmericanSans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Complete")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCompleteIcon);
export default __webpack_public_path__ + "static/media/Web_Complete_Icon.e897fbfe0a039b20afae6d31620b8328.svg";
export { ForwardRef as ReactComponent };